import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function SignInAfterSignUpErrorToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t("toasts.sign_in_after_sign_up_error.body")}
      id={props.id}
    />
  )
}
